import { Alert, Typography } from 'antd';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.black1};
  }
`;

export const Label = styled(Typography.Text)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const CustomAlert = styled(Alert)`
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background-color: ${({ theme }) => theme.colors.purple1};
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
